module.exports = __webpack_public_path__ + "static/media/white-modal-close-icon.26389d0e.svg";